import { RootState } from 'types'
import { Action } from 'redux/actions'

export default function reduce(
  state: RootState['websocket'] = { connection: null },
  action: Action,
): RootState['websocket'] {
  switch (action.type) {
    case 'SET_WEBSOCKET_CONNECTION': {
      return { ...state, ...action.payload }
    }

    default:
      return state
  }
}
